import homepagesService from '@/services/homepages.service';
import userAccountService from '@/services/user-account.service';

const state = {
    
    homepages: [],
    currentHomepage: ''
}

const mutations = {
    SET_CURRENT_HOMEPAGE(state, data){
        state.currentHomepage = data;
    },
    SET_HOMEPAGES(state, data){
        let homepages = [];
        data.forEach(homepage => {
            homepages.push(homepage);
        });
        state.homepages = homepages;
        
    }
}

const getters = {
    getHomepages: (state) =>{
        return state.homepages;
    },
    getCurrentHomepage(state) {
        return state.currentHomepage;
    }  
}

const actions = {

    async fetchHomepages({ commit }){
        const response = await homepagesService.getHomepages();
    
        commit("SET_HOMEPAGES", response.data);
        
        return response.data;
    },

    async setCurrentHomepage({ commit }, data){
        commit("SET_CURRENT_HOMEPAGE", data);
        return 
    },

    async fetchHomepage({ commit }, userId){
        const response = await userAccountService.getUserHomepage(userId);

        if(response.data){
            commit('SET_CURRENT_HOMEPAGE', response.data);
            return response.data;
        }
    },

    async updateHomepage({ commit }, data){
        const response = await userAccountService.updateHomepage(data);

        if(response.data){
            commit('SET_CURRENT_HOMEPAGE', response.data);
            return response.data;
        }
    }



}

export default {
    
    state,
    mutations,
    getters,
    actions
}